import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const EditDocFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M13.81 4.02h-7.1c-1.91 0-3.47 1.56-3.47 3.47v9.02c0 1.91 1.56 3.47 3.47 3.47h2.67v-1.1c0-.42.16-.82.43-1.12l7.47-8.1V7.48c0-1.91-1.56-3.47-3.47-3.47v.01Zm-3.28 8.42H6.61a.77.77 0 0 1 0-1.54h3.92a.77.77 0 0 1 0 1.54ZM13.4 9.1H6.6a.77.77 0 0 1 0-1.54h6.79a.77.77 0 0 1 0 1.54h.01ZM20.2 11.72l-1.04-1.04a.894.894 0 0 0-1.26 0l-1.22 1.22 2.31 2.31 1.22-1.22c.35-.35.35-.92 0-1.26l-.01-.01ZM10.4 20.42c-.06.21.13.4.34.33l2.67-.88-2.21-2.23-.8 2.78ZM16.34 12.31l-4.79 4.91 2.23 2.29 4.79-4.91-2.23-2.29Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default EditDocFilled
